const messages = {
  title: "À propos de BS Plus",
  description:
    "<b>VOTRE PLUS AVEC BRIDGESTONE</b> – tel est notre leitmotiv pour l'ensemble du programme <b>BRIDGESTONE PLUS</b> destiné à nos partenaires distributeurs. Découvrez les nombreux avantages exclusifs.",
};

export default {
  messages,
};
